export const TARIFF_ROUTE_NAMES = {
    PAY: "TariffPay",
};
